var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXhIsologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.186 97.6803L78.7809 78.7419L107.186 59.8035L107.186 97.6761M118.123 118.115L118.123 39.373L59.0618 78.746L118.123 118.115Z",
    fill: "#5BC1A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4042 39.373L69.9987 58.3114L69.9987 20.4346L98.4042 39.373ZM118.123 39.373L59.0617 -3.30992e-05L59.0617 78.7461L118.123 39.373Z",
    fill: "#FEC229"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3425 78.7459L10.9371 97.6844L10.9371 59.8117L39.3425 78.7501M59.0617 78.7501L6.10352e-05 39.3771L5.75931e-05 118.123L59.0617 78.7501Z",
    fill: "#36A8DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1247 58.3072L19.7192 39.3688L48.1247 20.4304L48.1247 58.3031M59.0617 78.7377L59.0617 -6.10352e-05L5.93141e-05 39.373L59.0617 78.746L59.0617 78.7377Z",
    fill: "#EE3854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXhIsologo);
export default __webpack_public_path__ + "static/media/XH-isologo.e71946c8b718b736dd1d6b7caaa62844.svg";
export { ForwardRef as ReactComponent };